<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Senseway</h2>
      <br />
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>

            <el-form-item label="Partner" prop="partner">
              <el-select
                @change="loadCustomers"
                v-model="query.partner"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in partnerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
                @change="load"
                v-model="query.customer"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="version">
              <el-row>
                <el-col :span="18">
                  <el-input
                    @keyup.enter.native="load"
                    placeholder="Please input"
                    v-model="query.version"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <el-button
                    style="margin-left: 5px"
                    :icon="sortIcon"
                    type="primary"
                    size="mini"
                    circle
                    @click="sortTypeChange()"
                  >
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Connection">
              <el-select
                @change="load"
                v-model="query.connectionStatus"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in connectionStatusSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Note">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.note"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.gateways"
            class="border"
          >
            <el-table-column type="index" label="Id">
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row._id)">
                  {{ itemIndex(scope) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="macAddress"
              label="macAddress"
              width="170px"
            />
            <el-table-column
              prop="certificateId"
              label="Certificate Id"
              width="150px"
            >
              <template slot-scope="scope">
                <span
                  style="font-size: 11px"
                  @click="copyIdToClipboard(scope.row.certificateId)"
                >
                  <abbr :title="scope.row.certificateId">{{
                    scope.row.certificateId
                  }}</abbr>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="customer" label="Customer">
            </el-table-column>
            <el-table-column prop="partner" label="Partner"> </el-table-column>

            <el-table-column label="Status" width="100">
              <template slot-scope="scope">
                <span>
                  <el-popover placement="left-end" width="100" trigger="hover">
                    <span>
                      {{ dayForm(scope.row.connectionDate) }}
                    </span>
                    <i
                      class="color-circle"
                      slot="reference"
                      v-bind:style="{
                        'background-color': statusColor(
                          scope.row.connectionStatus
                        ),
                      }"
                    ></i>
                  </el-popover>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Routings">
              <template slot-scope="scope">
                <span>
                  <el-button
                    size="mini"
                    @click="showAvaliableDevicesDialog(scope)"
                    >Available Devices</el-button
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="version" label="Version" width="180px;">
              <template slot-scope="scope">
                <el-row>
                  <el-col
                    v-if="
                      !editShowLine || form.macAddress != scope.row.macAddress
                    "
                    :span="18"
                  >
                    <span>
                      {{ scope.row.version }}
                    </span>
                  </el-col>
                  <el-col
                    :span="12"
                    v-show="
                      editShowLine && form.macAddress == scope.row.macAddress
                    "
                  >
                    <el-select
                      clearable
                      v-model="form.firmware"
                      placeholder="Select"
                      size="mini"
                    >
                      <el-option
                        v-for="item in firmwares"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col
                    :span="6"
                    v-show="
                      editShowLine && form.macAddress == scope.row.macAddress
                    "
                  >
                    <el-button
                      style="margin-left: 5px"
                      icon="el-icon-upload"
                      type="primary"
                      size="mini"
                      circle
                      @click="firmwareUpdate(form)"
                    ></el-button>
                  </el-col>
                  <el-col
                    v-show="
                      otaInPorgress && form.macAddress == scope.row.macAddress
                    "
                    :span="6"
                  >
                    <el-progress
                      :width="40"
                      type="circle"
                      :percentage="otaProgress"
                    ></el-progress>
                  </el-col>
                  <el-col
                    :span="6"
                    v-show="scope.row.connectionStatus == 'connected'"
                  >
                    <el-button
                      style="float: right"
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      @click="Edit(scope, 'line')"
                      circle
                      CA:B8:31:00:00:4B
                      :loading="
                        editVersionLoading &&
                        form.macAddress == scope.row.macAddress
                      "
                    ></el-button>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>

            <el-table-column label="Actions" width="350px">
              <template slot-scope="scope">
                <el-button
                  v-if="editId == scope.row._id && false"
                  @click="UpdateGateway(scope)"
                  >Save</el-button
                >
                <el-button v-if="editId == scope.row._id" @click="Cancel(scope)"
                  >Cancel</el-button
                >
                <el-button v-if="!editId" size="mini" @click="newCert(scope)"
                  >New Cert.</el-button
                >

                <el-popover placement="left-end" width="500" trigger="hover">
                  <p style="white-space: pre-wrap">{{ infoJson(scope.row) }}</p>
                  <el-button
                    style="margin-left: 10px"
                    size="mini"
                    slot="reference"
                    icon="el-icon-info"
                  ></el-button>
                </el-popover>
                <el-button
                  v-if="!editId"
                  size="mini"
                  style="margin-left: 10px"
                  @click="ShowConnectionLogs(scope)"
                  >Connectivity</el-button
                >
                <el-popover
                  placement="bottom"
                  style="margin-left: 10px"
                  width="200"
                  trigger="click"
                >
                  <el-row>
                    <el-col>
                      <el-input
                        type="textarea"
                        placeholder="take note"
                        :maxlength="250"
                        :show-word-limit="true"
                        v-model="scope.row.note"
                        size="small"
                      />
                    </el-col>
                    <el-col>
                      <el-button
                        style="margin-top: 10px; float: right"
                        size="mini"
                        @click="UpdateGateway(scope.row)"
                      >
                        Save</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-button
                    icon="el-icon-notebook-2"
                    slot="reference"
                    size="mini"
                  ></el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog
      width="30%"
      title="Download Certificates"
      :visible.sync="showCertsForm"
    >
      <el-form
        v-if="certs"
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="230px"
        label-position="left"
        style="text-align: center"
      >
        <el-alert title="WARNING" type="" show-icon>
          You wont able to access this page, make sure you have downloaded
          required files from below</el-alert
        >
        <el-form-item label="CA Certificate" style="margin-top: 15px">
          <el-button @click="downloadCa('AWSRootCA1')">Download </el-button>
        </el-form-item>
        <el-form-item label="Device Certificate">
          <el-button @click="downloadCert('cert', certs.certificatePem)"
            >Download
          </el-button>
        </el-form-item>
        <el-form-item label="Device Private Key">
          <el-button @click="downloadCert('private', certs.keyPair.PrivateKey)"
            >Download
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      width="30%"
      title="Avaliable Devices"
      :visible.sync="showAvailableDevices"
    >
      <el-table :data="availableDevices" class="border">
        <el-table-column type="index" label="Id"> </el-table-column>
        <el-table-column prop="_id.device" label="device" />
        <el-table-column prop="_id.gateway" label="gateway" />
        <el-table-column prop="rssi" label="rssi" width="100px;" />
      </el-table>
    </el-dialog>
    <el-dialog
      width="80%"
      :title="connectivityLogTitle"
      :visible.sync="connectivityLogVisible"
      :loading="connectivityLogLoading"
    >
      <Plotly
        @hover="connectivityOnHover"
        :data="connectivityData"
        :layout="layout"
        :display-mode-bar="false"
      ></Plotly>
    </el-dialog>

    <el-dialog
      width="80%"
      :title="connectivityLogTitle"
      :visible.sync="connectivityLogVisible"
      :loading="connectivityLogLoading"
    >
      <Plotly
        @hover="connectivityOnHover"
        :data="connectivityData"
        :layout="layout"
        :display-mode-bar="false"
      ></Plotly>
    </el-dialog>
  </div>
</template>



<script>
import { Plotly } from "vue-plotly";

import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";
import beautify from "json-beautify";
import gatewayService from "../service/gateway";
import moment from "moment";
import iot from "../service/iot";
import mqtt from "mqtt";

export default {
  name: "Gateway",
  components: { TheMask, Plotly },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      selectedGateway: "",
      availableDevices: [],
      showAvailableDevices: false,
      editShowLine: false,
      editVersionLoading: false,
      versionUpdated: false,
      otaInPorgress: false,
      otaProgress: 0,
      sortIcon: "el-icon-d-caret",
      query: {
        macAddress: "",
        partner: "",
        customer: "",
        version: "",
        connectionStatus: "",
        page: 1,
        pageSize: 10,
        note: "",
        sortType: "",
        sortDirection: -1,
      },
      connectivityData: [],
      layout: {
        yaxis: {
          type: "category",
          categoryorder: "category descending",
        },
        margin: {
          r: 50,
          b: 100,
          t: 100,
          pad: 4,
        },
      },
      pageSizes: [10, 25, 50, 75],
      certs: {},
      connectivityLogVisible: false,
      showCertsForm: false,
      filterGateway: null,
      editId: "",
      showForm: false,
      formLoading: false,
      connectivityLogLoading: false,
      connectionStatusSelect: [
        {
          value: "undefined",
          label: `undefined`,
          key: "undefined",
        },
        {
          value: "disconnected",
          label: `disconnected`,
          key: "disconnected",
        },
        {
          value: "connected",
          label: `connected`,
          key: "connected",
        },
      ],
      form: {
        macAddress: "",
        customer: "",
        note: "",
      },
      rules: {
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getGateways(this.query);
    this.getPartners();
    this.getCustomers();
  },
  computed: {
    connectivityLogTitle() {
      return (
        "Connectivity log for : " +
        (this.selectedGateway ? this.selectedGateway.macAddress : "")
      );
    },
    ...mapState("gateway", ["searchResult", "loading", "firmwares"]),
    ...mapState("partner", ["customers", "partners"]),
    partnerFilterSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          text: x.name,
        };
      });
    },
    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    customerFilterSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          text: x.name,
        };
      });
    },
    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    ...mapActions("gateway", [
      "getGateways",
      "updateGateway",
      "deleteGateway",
      "newCertGateway",
      "getGatewayFirmwares",
      "updateGatewayFirmwares",
      "getGatewayVersion",
    ]),
    ...mapActions("partner", ["getCustomers", "getPartners"]),
    sortTypeChange() {
      switch (this.sortIcon) {
        case "el-icon-d-caret":
          this.sortIcon = "el-icon-caret-bottom";
          this.query.sortType = "version";
          this.query.sortDirection = -1;
          break;
        case "el-icon-caret-bottom":
          this.sortIcon = "el-icon-caret-top";
          this.query.sortType = "version";
          this.query.sortDirection = 1;
          break;
        case "el-icon-caret-top":
          this.sortIcon = "el-icon-d-caret";
          this.query.sortType = "";
          this.query.sortDirection = -1;
          break;
        default:
          this.sortIcon = "el-icon-d-caret";
          this.query.sortType = "";
          this.query.sortDirection = -1;
          break;
      }
    },
    UpdateGateway(scope) {
      this.updateGateway({
        _id: scope._id,
        note: scope.note,
      })
        .then(() => {
          this.showForm = false;
          this.load();
        })
        .finally(() => {
          this.editId = "";
          this.form = {
            macAddress: "",
            customer: "",
            note: "",
          };
        });
    },
    async loadCustomers() {
      this.query.customer = "";
      await this.getCustomers({ partner: this.query.partner });
      await this.load();
    },
    initiateMqtt() {
      return new Promise((res, rej) => {
        this.disconnect();
        iot
          .getSigv4Url()
          .then((x) => {
            this.connecting = true;
            var self = this;
            if (self.mqttClient) {
              self.mqttClient.end(true);
            }
            self.mqttClient = mqtt.connect(x.url, {
              protocol: "wss",
              clientId: self.$uuid.v1(),
            });

            self.mqttClient.on("connect", () => {});
            self.mqttClient.once("error", (e) => {
              self.$mesasge.info("error occured", e);
            });
            self.mqttClient.on("error", () => {
              self.$message.error("Someting went wrong");
            });
            self.mqttClient.on("reconnect", () => {});
            self.mqttClient.on("close", () => {});
            self.mqttClient.on("disconnect", () => {});
            self.mqttClient.on("offline", () => {});
            self.mqttClient.on("message", self.onMessage);
            let subscribeArray = [];
            if (this.form.firmware.split("/")[1].split("-")[1] == "SENSEWAY") {
              subscribeArray.push(
                `prod/gateway/${this.form.macAddress}/info/+`
              );
            } else {
              subscribeArray.push(
                `prod/gateway/${this.form.macAddress}/client/${
                  this.form.firmware.split("/")[1].split("-")[1]
                }/version/rejected`,
                `prod/gateway/${this.form.macAddress}/client/${
                  this.form.firmware.split("/")[1].split("-")[1]
                }/version/accepted`
              );
            }
            self.mqttClient.subscribe(
              [
                `prod/gateway/${this.form.macAddress}/client/${
                  this.form.firmware.split("/")[1].split("-")[1]
                }/ota/accepted`,
                `prod/gateway/${this.form.macAddress}/client/${
                  this.form.firmware.split("/")[1].split("-")[1]
                }/ota/rejected`,
                `prod/gateway/${this.form.macAddress}/client/${
                  this.form.firmware.split("/")[1].split("-")[1]
                }/ota/done`,
                ...subscribeArray,
              ],
              (err) => {
                if (!err) {
                  res("ok");
                } else {
                  console.log(err);
                  rej(err);
                }
              }
            );
          })
          .catch((e) => {
            console.log(e);
            this.connecting = false;
          });
      });
    },
    onMessage(topic, payload) {
      let messageString = payload.toString();
      let topicTokens = topic.split("/");
      if (
        topicTokens[topicTokens.length - 1] === "rejected" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 0;
        this.otaInPorgress = false;
        this.$message.error(
          `${topicTokens[2]} ${topicTokens[4]} rejected OTA. ${messageString}`
        );
        this.editShowLine = false;
        this.versionUpdated = true;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "accepted" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 30;
        this.otaInPorgress = true;
        this.$message.success(
          `${topicTokens[2]} ${topicTokens[4]} accepted OTA`
        );
      } else if (
        topicTokens[topicTokens.length - 1] === "done" &&
        topicTokens[topicTokens.length - 2] === "ota"
      ) {
        this.otaProgress = 100;
        setTimeout(() => {
          this.otaInPorgress = false;
        }, 500);
        this.$message.success(`${topicTokens[2]} ${topicTokens[4]} done OTA`);
        this.versionUpdated = true;

        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "accepted" &&
        topicTokens[topicTokens.length - 2] === "version"
      ) {
        let newVersion = this.form.firmware
          .slice(
            this.form.firmware.indexOf("version") + 8,
            this.form.firmware.indexOf(".")
          )
          .replaceAll("-", ".");
        if (newVersion == messageString.split("-")[0]) {
          this.otaProgress = 100;
          setTimeout(() => {
            this.otaInPorgress = false;
          }, 500);
          this.$message.success(
            `${topicTokens[topicTokens.length - 3]} done OTA`
          );
        } else {
          this.otaProgress = 0;
          this.otaInPorgress = false;
          this.$message.error(
            `${topicTokens[topicTokens.length - 3]} error during OTA`
          );
        }

        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "rejected" &&
        topicTokens[topicTokens.length - 2] === "version"
      ) {
        this.$message.error(
          `${
            topicTokens[topicTokens.length - 3]
          } rejected version. OTA may not done`
        );
        this.otaProgress = 0;
        this.otaInPorgress = false;
        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      } else if (
        topicTokens[topicTokens.length - 1] === "accepted" &&
        topicTokens[topicTokens.length - 2] === "info" &&
        this.form.firmware.split("/")[1].split("-")[1] == "SENSEWAY"
      ) {
        if (
          this.form.firmware
            .slice(
              this.form.firmware.indexOf("version") + 8,
              this.form.firmware.indexOf(".")
            )
            .replaceAll("-", ".") == JSON.parse(payload).Version
        ) {
          this.$message.success(
            `${topicTokens[topicTokens.length - 3]} done OTA`
          );
        } else {
          this.$message.error(
            `${topicTokens[topicTokens.length - 3]} error during OTA`
          );
        }
        this.versionUpdated = true;
        this.editShowLine = false;
        this.editVersionLoading = false;
        this.disconnect();
      }
    },
    updatedVersionLoop() {
      setTimeout(() => {
        if (!this.versionUpdated) {
          this.getGatewayVersion({
            gateway: this.form.macAddress,
            client: this.form.firmware.split("/")[1].split("-")[1],
            type: "SENSEWAY",
          });
        }
      }, 60000);
      setTimeout(() => {
        if (!this.versionUpdated) {
          this.$message.error(`${this.form.macAddress} TIME_OUT`);
          this.otaProgress = 0;
          this.otaInPorgress = false;
          this.versionUpdated = true;
          this.editShowLine = false;
          this.editVersionLoading = false;
          this.disconnect();
        }
      }, 90000);
    },
    disconnect() {
      this.connecting = false;
      this.connected = false;
      if (this.mqttClient) {
        this.mqttClient.end(true);
      }
    },
    async firmwareUpdate(form) {
      if (form.firmware) {
        this.editShowLine = false;
        this.editVersionLoading = true;
        await this.initiateMqtt();
        this.otaProgress = 10;
        this.otaInPorgress = true;
        this.updateGatewayFirmwares(this.form).then((data) => {
          if (data == undefined) {
            this.otaProgress = 0;
            setTimeout(() => {
              this.otaInPorgress = false;
            }, 500);
            this.versionUpdated = true;
            this.editShowLine = false;
            this.editVersionLoading = false;
            this.disconnect();
          } else {
            this.updatedVersionLoop();
          }
        });
        this.showForm = false;
        this.editShowform = false;
      } else {
        this.$message.error("Please select firmware version");
      }
    },
    showAvaliableDevicesDialog(scope) {
      this.availableDevices = scope.row.availableDevices;
      this.showAvailableDevices = true;
    },
    itemIndex(scope) {
      return this.query.pageSize * (this.query.page - 1) + scope.$index + 1;
    },
    downloadCa() {
      this.download(
        "AWSrootCA.txt",
        `-----BEGIN CERTIFICATE-----
MIIDQTCCAimgAwIBAgITBmyfz5m/jAo54vB4ikPmljZbyjANBgkqhkiG9w0BAQsF
ADA5MQswCQYDVQQGEwJVUzEPMA0GA1UEChMGQW1hem9uMRkwFwYDVQQDExBBbWF6
b24gUm9vdCBDQSAxMB4XDTE1MDUyNjAwMDAwMFoXDTM4MDExNzAwMDAwMFowOTEL
MAkGA1UEBhMCVVMxDzANBgNVBAoTBkFtYXpvbjEZMBcGA1UEAxMQQW1hem9uIFJv
b3QgQ0EgMTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALJ4gHHKeNXj
ca9HgFB0fW7Y14h29Jlo91ghYPl0hAEvrAIthtOgQ3pOsqTQNroBvo3bSMgHFzZM
9O6II8c+6zf1tRn4SWiw3te5djgdYZ6k/oI2peVKVuRF4fn9tBb6dNqcmzU5L/qw
IFAGbHrQgLKm+a/sRxmPUDgH3KKHOVj4utWp+UhnMJbulHheb4mjUcAwhmahRWa6
VOujw5H5SNz/0egwLX0tdHA114gk957EWW67c4cX8jJGKLhD+rcdqsq08p8kDi1L
93FcXmn/6pUCyziKrlA4b9v7LWIbxcceVOF34GfID5yHI9Y/QCB/IIDEgEw+OyQm
jgSubJrIqg0CAwEAAaNCMEAwDwYDVR0TAQH/BAUwAwEB/zAOBgNVHQ8BAf8EBAMC
AYYwHQYDVR0OBBYEFIQYzIU07LwMlJQuCFmcx7IQTgoIMA0GCSqGSIb3DQEBCwUA
A4IBAQCY8jdaQZChGsV2USggNiMOruYou6r4lK5IpDB/G/wkjUu0yKGX9rbxenDI
U5PMCCjjmCXPI6T53iHTfIUJrU6adTrCC2qJeHZERxhlbI1Bjjt/msv0tadQ1wUs
N+gDS63pYaACbvXy8MWy7Vu33PqUXHeeE6V/Uq2V8viTO96LXFvKWlJbYK8U90vv
o/ufQJVtMVT8QtPHRh8jrdkPSHCa2XV4cdFyQzR1bldZwgJcJmApzyMZFo6IQ6XU
5MsI+yMRQ+hDKXJioaldXgjUkK642M4UwtBV8ob2xJNDd2ZhwLnoQdeXeGADbkpy
rqXRfboQnoZsG4q5WTP468SQvvG5
-----END CERTIFICATE-----`
      );
    },
    dayForm(time) {
      if (time == undefined) {
        return "N/A";
      } else {
        return moment(time).fromNow(true);
      }
    },
    infoJson(row) {
      return `${beautify(row, null, 5)}`;
    },
    statusColor(connectionStatus) {
      if (!connectionStatus) {
        return "#ffff00";
      } else if (connectionStatus == "disconnected") {
        return "#ff0000";
      } else if (connectionStatus == "connected") {
        return "#00FF00";
      } else {
        return "#808080";
      }
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    downloadCert(filename, text) {
      this.download(
        this.form.macAddress.replace(/:/, "_") + "_" + filename,
        text
      );
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    connectivityOnHover(event) {
      if (event.points && event.points.length) {
        let point = event.points[0];
        let index = point.pointIndex;
        console.log(index);
        if (index != 0) {
          let prevData = this.connectivityData[0].x[index + 1];
          let current = this.connectivityData[0].x[index];
          console.log(current, prevData);
          console.log(moment(current).diff(prevData, "minutes"));
        }
      }
    },
    ShowConnectionLogs(scope) {
      this.connectivityLogLoading = true;
      this.selectedGateway = scope.row;
      this.connectivityLogVisible = true;
      gatewayService
        .getConnectionLogs(this.selectedGateway._id)
        .then((x) => {
          //todo
          console.log(x);
          let eventTypes = x.map((x) => x.status.eventType);
          let timestamps = x.map((x) => new Date(x.status.timestamp));
          this.connectivityData = [
            {
              x: timestamps,
              y: eventTypes,
              mode: "lines+markers",
              line: { shape: "vh" },
              type: "scatter",
            },
          ];

          console.log(this.connectivityData);
        })
        .finally(() => {
          this.connectivityLogLoading = false;
        });
    },

    load() {
      this.getGateways(this.query);
    },
    newCert(scope) {
      this.$confirm(
        "This will permanently delete current certificate of the gateway and create new certificate. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$confirm(
            "!!!This will permanently delete current certificate of the gateway and create new certificate!!!. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => this.newCertGateway(scope.row._id))
            .then((data) => {
              this.certs = data.certs;
              this.showCertsForm = true;
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => {
              this.formLoading = false;
              this.load();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "New certification canceled",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "New certification canceled",
          });
        });
    },
    Delete(scope) {
      this.$confirm(
        "This will permanently delete the gateway. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$confirm(
            "!!!Really sure to delete the gateway. Continue?!!!",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => this.deleteGateway(scope.row._id))
            .then(() => this.getGateways(this.query))
            .catch(() => {
              this.$message({
                type: "info",
                message: "Delete canceled",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Cancel() {
      this.editId = "";
      this.form = {
        customer: "",
      };
    },
    Edit(scope) {
      this.editShowLine = !this.editShowLine;
      if (this.editShowLine) {
        this.form = {
          _id: scope.row._id,
          macAddress: scope.row.macAddress,
        };
        this.editVersionLoading = true;
        this.getGatewayFirmwares(this.form).then(() => {
          this.editVersionLoading = false;
          this.editShowLine = true;
        });
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>